<div
  [id]="mapId"
  class="matp-map tw-w-full tw-h-full"
  [style.height]="mapHeight || null"
  [style.height.px]="mapHeight ? null : mapHeightPx"
></div>
